<template>
    <modal :show.sync=show bodyClasses="p-0" :hide-footer="true">
        <b-row slot="header" align-v="center" class="w-100">
            <b-col cols="10">
                <h3  class="mb-0 font-weight-500">Bank Comparison Result</h3>
            </b-col>
            <!-- <b-col cols="2">
                <el-button class="float-right py-0 text-primary" type="text">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 512 512"><path fill="currentColor" d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v242.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-32c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/></svg>
                    Download
                </el-button>
            </b-col> -->
        </b-row>
        <div class="table-compare-banks">
            <b-table-simple responsive>
                <b-thead>
                    <b-tr>
                        <b-th class="border-0"></b-th>
                        <b-th v-for="(bank, index) in banks" :key="index" class="border-0">
                            <el-image style="height: 25px;" :src="bank.bank_image_url" fit="contain">
                                <template #error>
                                    <div class="image-slot">
                                        <span>{{ bank.bank_name }}</span>
                                    </div>
                                </template>
                            </el-image>
                        </b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <!-- Salary -->
                    <b-tr>
                        <b-th class="font-weight-700">Salary</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_salary_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="font-weight-500">Business Income</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_business_income_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="font-weight-500">Fixed Allowance</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_fixed_allowance_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="font-weight-500">Variable Income</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_variable_income_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="font-weight-500">Commission Income</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_commission_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <!-- Gross Income -->
                    <b-tr>
                        <b-th class="font-weight-700">Gross Income</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_gross_income_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="font-weight-500">EPF Amount</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_epf_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="font-weight-500">Income Tax</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_tax_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="font-weight-500">SOCSO Amount</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_sosco_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="font-weight-500">Bonus Income</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_bonus_average_after_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="font-weight-500">Rental Income</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_rental_income_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <!-- Net Income -->
                    <b-tr>
                        <b-th class="font-weight-700">Net Income</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_net_income_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="font-weight-700">Actual DSR Rate</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index"> {{bank.bank_actual_dsr_rate}} %</b-td>
                    </b-tr>
                    <b-tr variant="danger">
                        <b-th class="font-weight-700">Final Accepted Income</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index" class="font-weight-700">RM {{ bank.bank_final_acceptance_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="font-weight-500">Total Commitment</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_total_commitment_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="font-weight-500">Installable Amount</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_installable_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    <template v-if="product_selected === 'pl' && _gHlp.checkRoleType( ['admin', 'manager', 'director'])">
                        <b-tr variant="warning">
                            <b-th>DSR Formula Check</b-th>
                            <b-td v-for="(bank, index) in banks" :key="index">CONFIDENTIAL</b-td>
                        </b-tr>
                        <b-tr variant="primary">
                            <b-th class="font-weight-500">Unsecured Outstanding Based On</b-th>
                            <b-td v-for="(bank, index) in banks" :key="index"><div v-if="bank.bank_pl_breakdown_formula.bank_pl_unsecure_type == ''"> Not Enabled </div> <div v-if="bank.bank_pl_breakdown_formula.bank_pl_unsecure_type !== ''"> {{ bank.bank_pl_breakdown_formula.bank_pl_unsecure_type }} <br/> - {{ bank.bank_pl_breakdown_formula.TotOutVar }} <br/> - <b>{{ bank.bank_pl_breakdown_formula.TotOut | moneyFormatter }}</b> </div></b-td>
                        </b-tr>
                        <b-tr variant="primary">
                            <b-th class="font-weight-500">Max Loan Rate By</b-th>
                            <b-td v-for="(bank, index) in banks" :key="index"><b style="font-size:22px">{{ bank.bank_pl_max_loan_range_by }}</b> </b-td>
                        </b-tr>
                        <b-tr variant="primary">
                            <b-th class="font-weight-500">Max Loan Rate</b-th>
                            <b-td v-for="(bank, index) in banks" :key="index"><b>{{ bank.bank_pl_breakdown_formula.Max_Loan_Rate }} %</b> </b-td>
                        </b-tr>
                        <b-tr variant="primary">
                            <b-th class="font-weight-500">Max Loan Rate Amount</b-th>
                            <b-td v-for="(bank, index) in banks" :key="index"><b>{{ bank.bank_pl_breakdown_formula.Max_Loan_Rate_Amt  | moneyFormatter }}</b> </b-td>
                        </b-tr>
                        <b-tr variant="primary">
                            <b-th class="font-weight-500">Max Amount Formula</b-th>
                            <b-td v-for="(bank, index) in banks" :key="index"><b>{{ bank.bank_pl_breakdown_formula.MaxLoanAmtLeft  | moneyFormatter }}</b> <br/> - {{ bank.bank_pl_breakdown_formula.MaxAmtLeftVar }}</b-td>
                        </b-tr>
                        <b-tr>
                        <b-th class="font-weight-700">Bank Min Loan</b-th>
                            <b-td v-for="(bank, index) in banks" :key="index" class="font-weight-700">RM {{ bank.bank_min_loan_amount | moneyFormatter }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="font-weight-700">Bank Max Loan</b-th>
                            <b-td v-for="(bank, index) in banks" :key="index" class="font-weight-700">RM {{ bank.bank_max_loan_amount | moneyFormatter }}</b-td>
                        </b-tr>
                    </template>
                    <b-tr>
                        <b-th class="font-weight-500">Loan Interest</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index">{{bank.bank_loan_interest_rate}}%</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="font-weight-500">Tenure Year</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index">{{  bank.bank_loan_tenure_year }}</b-td>
                    </b-tr>
                    
                    <b-tr variant="danger">
                        <b-th class="font-weight-700">Loan Eligible</b-th>
                        <b-td v-for="(bank, index) in banks" :key="index" class="font-weight-700">RM {{ bank.bank_loan_eligibility_amount | moneyFormatter }}</b-td>
                    </b-tr>
                    
                    <template v-if="product_selected === 'refinance'">
                        <b-tr>
                            <b-th class="font-weight-500">Refinance Loan Amount</b-th>
                            <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_refinance_loan_amount | moneyFormatter }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="font-weight-500">Refinance Loan Margin</b-th>
                            <b-td v-for="(bank, index) in banks" :key="index">{{ bank.bank_refinance_loan_margin | moneyFormatter }}%</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="font-weight-500">Refinance Instalment Amount</b-th>
                            <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_refinance_instalment | moneyFormatter }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="font-weight-500">Bank Outstanding</b-th>
                            <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_refinance_bank_outstanding | moneyFormatter }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="font-weight-500">Bank Outstanding Instalment</b-th>
                            <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_refinance_bank_outstanding_instalment | moneyFormatter }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="font-weight-500">Cashout</b-th>
                            <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_refinance_cashout_amount | moneyFormatter }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="font-weight-500">Cashout Instalment</b-th>
                            <b-td v-for="(bank, index) in banks" :key="index">RM {{ bank.bank_refinance_cashout_instalment | moneyFormatter }}</b-td>
                        </b-tr>
                    </template>
                </b-tbody>
                

            </b-table-simple>
        </div>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Image, Button } from 'element-ui'
import helperFunctionMixin from '@/assets/js/helperFunctionMixin'

export default {
    props:{
        compare_banks: Boolean,
        banks: Array,
        product_selected: {
            type: [String, null],
            default: null
        }
    },
    mixins: [helperFunctionMixin],
    components: {
        Modal,
        [Image.name]: Image,
        [Button.name]: Button,
    },
    computed: {
        show: {
            get() {
                return this.compare_banks;
            },
            set(newVal) {
                this.$emit('update:compare_banks', newVal);
            },
        },
    }
}
</script>